import { defineRule } from '../define-rule'
import { assertNumber, assertTypes, toNumber } from '@/libs/utils'
import type { BaseRuleConstructorParams } from '../ts/rule-constructor-parameter.type'

export type BetweenRuleConstructorParams = BaseRuleConstructorParams<{ min: number; max: number }>

export const between = defineRule(
  'between',
  ({ config, errorMessage }: BetweenRuleConstructorParams) => {
    const { min, max } = config
    assertNumber(min)
    assertNumber(max)
    const errorCase = errorMessage ?? false
    return (value: string | number) => {
      try {
        assertTypes(value, 'string', 'number')
        const castedValue = toNumber(value as string | number)
        return (castedValue >= min && castedValue <= max) || errorCase
      } catch {
        return errorCase
      }
    }
  }
)
